export const RouteMap = {
  "": "",
  logout: "logout",
  ticket_module_admin: "ticket-module-admin",
  postings_overview_admin: "postings-overview-admin",
};

export const SettingRoutes = {

};

export const InnovationLabRoutes = {
};
export const CourseRoutes = {
  // course: "course",
};

export const URLAccessibleWithoutSession = {
  login: "login",
};

export const RouteMapDetails = {
  "": "",
  dashboard: {
    title_key: "v2_seo_campaign_dashboard_page_title",
  },
 
};
